import { combineReducers } from "redux";
import Auth from "./Auth";
import Wellness from "./Wellness";

const reducers = combineReducers({
  auth: Auth,
  wellness: Wellness,
});

export default reducers;
